/**
 * Contain the Style for the Home View
 */

//ColorManager
import ColorManager from "./../managers/ColorManager";

export default {
    tabs: {
        backgroundColor: ColorManager.primaryColor,
        bottom: 0,
        left: 0,
        position: "fixed",
        right: 0
    },

    indicatorColor: ColorManager.lightPrimaryColor,

    tabContainer: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },

    icon: {
        color: ColorManager.text
    },

    slide: {
        height: "100%",
        minHeight: 100,
        padding: 5
    }
};



// WEBPACK FOOTER //
// ./src/app/styles/Home.ts